export default (): VideoComponent => {
    return {
        handlePlay(videoType: string) {
            this.$refs.prevideo.style.display = "none";

            if (videoType !== "") {
                if (videoType !== "html-video" && videoType !== "embedded") {
                    (this.$refs.player as any).src =
                        (this.$refs.player as any).src +
                        "?autoplay=1&mute=1&muted=1";
                        
                } else if(videoType === "html-video"){
                    (this.$refs.player as any).play();
                   
                }
                
                (this.$refs.player as any).classList.remove("hidden");
            }
        },
    };
};

import { AlpineComponent } from "alpinejs";

type VideoComponent = AlpineComponent<{
    handlePlay: Function;
}>;
